/*
 * Scuderia: oferta 3x2 interactiva en la ficha de producto.
 * Elemento <scuderia-bundle> (blocks/scuderia-oferta-3x2.liquid).
 *  - "Compra 1": producto de la ficha + selector de talla (sincronizado con el selector principal).
 *  - "Compra 2, llevate 3": 3 huecos; el 1º es el producto de la ficha, los otros 2 se eligen en una
 *    ventana con productos del mismo tipo. Al completar los 3, un boton los añade al carrito y el
 *    descuento automatico "Compra X, lleva Y" (Admin) se aplica solo en el carrito.
 */
(function () {
  if (customElements.get('scuderia-bundle')) return;

  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  class ScuderiaBundle extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      const json = this.querySelector('script[data-bundle]');
      if (!json) return;
      this._ready = true;

      const data = JSON.parse(json.textContent);
      this.products = data.products.filter((p) => p.variants.some((v) => v.available));
      this.current = this.products.find((p) => p.id === data.currentId) || null;
      if (!this.current) return;

      this.mode = 'one';
      this.slots = [null, null, null];
      const cv = this.current.variants.find((v) => v.id === data.currentVariant && v.available) || this.current.variants.find((v) => v.available);
      this.slots[0] = { product: this.current, variantId: cv.id };
      this.oneVariantId = cv.id;
      this.t = this.dataset;

      this.panelOne = this.querySelector('[data-panel="one"]');
      this.panelThree = this.querySelector('[data-panel="three"]');
      this.savingEl = this.querySelector('[data-saving]');
      this.addBtn = this.querySelector('[data-add]');
      this.errorEl = this.querySelector('[data-error]');
      this.modal = this.querySelector('[data-modal]');

      this.querySelectorAll('input[type="radio"]').forEach((r) => r.addEventListener('change', () => this.setMode(r.value)));
      this.addBtn.addEventListener('click', () => this.addToCart());
      this.addEventListener('change', (e) => this.onSelect(e));
      this.addEventListener('click', (e) => this.onClick(e));
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) this.modal.close();
      });

      this.renderOne();
      this.renderThree();
      this.updateSummary();

      // Si el tema vuelve a pintar la seccion (cambio de talla en la ficha), se repone el contenido de los paneles
      this._observer = new MutationObserver(() => {
        if (this._restoring) return;
        this._restoring = true;
        requestAnimationFrame(() => {
          if (!this.panelOne.childElementCount) this.renderOne();
          if (!this.panelThree.childElementCount) this.renderThree();
          this._restoring = false;
        });
      });
      this._observer.observe(this, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
    }

    /* ---------- utilidades ---------- */
    money(cents) {
      if (!this._fmt) {
        const sample = this.dataset.moneySample || '';
        const m = sample.match(/\d[\d.,'’   ]*\d/);
        if (m) {
          const num = m[0];
          const dec = /[.,]\d{2}$/.test(num) ? num.slice(-3, -2) : '';
          const rest = dec ? num.slice(0, -3) : num;
          const thou = rest.replace(/\d/g, '').charAt(0) || '';
          this._fmt = { pre: sample.slice(0, m.index), post: sample.slice(m.index + num.length), dec, thou };
        } else {
          this._fmt = { pre: '', post: '', dec: '.', thou: ',' };
        }
      }
      const f = this._fmt;
      let [a, b] = (cents / 100).toFixed(2).split('.');
      if (f.thou) a = a.replace(/\B(?=(\d{3})+(?!\d))/g, f.thou);
      return f.pre + a + (f.dec ? f.dec + b : '') + f.post;
    }

    variantOf(product, id) {
      return product.variants.find((v) => v.id === id);
    }

    sizeSelect(product, selectedId, attrs) {
      const opts = product.variants
        .map((v) => `<option value="${v.id}" ${v.id === selectedId ? 'selected' : ''} ${v.available ? '' : 'disabled'}>${esc(v.label)}${v.available ? '' : ' (' + esc(this.t.tSoldOut) + ')'}</option>`)
        .join('');
      return `<select aria-label="${esc(this.t.tSize)}" ${attrs}>${opts}</select>`;
    }

    thumb(product) {
      return `<span class="sc-offer__thumb" style="background-image:url('${esc(product.image)}')"></span>`;
    }

    /* ---------- modos ---------- */
    setMode(mode) {
      this.mode = mode;
      this.querySelectorAll('[data-opt]').forEach((o) => o.classList.toggle('is-active', o.dataset.opt === mode));
      this.panelOne.hidden = mode !== 'one';
      this.panelThree.hidden = mode !== 'three';
      // En modo 3x2 las tallas se eligen aqui: se oculta el selector y el boton normales de la ficha
      const section = this.closest('.shopify-section') || document;
      const hide = (sel) => {
        section.querySelectorAll(sel).forEach((el) => {
          if (mode === 'three') {
            if (el.dataset.scHidden === undefined) el.dataset.scHidden = el.style.display || '';
            el.style.display = 'none';
          } else if (el.dataset.scHidden !== undefined) {
            el.style.display = el.dataset.scHidden;
            delete el.dataset.scHidden;
          }
        });
      };
      hide('variant-picker');
      hide('.buy-buttons-block');
      this.updateSummary();
    }

    /* ---------- render ---------- */
    renderOne() {
      const p = this.current;
      this.panelOne.innerHTML = `
        <div class="sc-offer__slot">
          ${this.thumb(p)}
          <div class="sc-offer__slot-info">
            <span class="sc-offer__slot-title">${esc(p.title)}</span>
            ${this.sizeSelect(p, this.oneVariantId, 'data-one-size')}
          </div>
        </div>`;
    }

    renderThree() {
      this.panelThree.innerHTML = this.slots
        .map((s, i) => {
          if (!s) {
            return `<div class="sc-offer__slot">
              <button type="button" class="sc-offer__thumb sc-offer__thumb--empty" data-choose="${i}" aria-label="${esc(this.t.tChoose)}"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg></button>
              <div class="sc-offer__slot-info"></div>
              <button type="button" class="sc-offer__btn" data-choose="${i}">${esc(this.t.tChoose)}</button>
            </div>`;
          }
          return `<div class="sc-offer__slot">
            ${this.thumb(s.product)}
            <div class="sc-offer__slot-info">
              <span class="sc-offer__slot-title">${esc(s.product.title)}</span>
              ${this.sizeSelect(s.product, s.variantId, `data-slot-size="${i}"`)}
            </div>
            ${i === 0 ? '' : `<button type="button" class="sc-offer__btn sc-offer__btn--ghost" data-choose="${i}">${esc(this.t.tChange)}</button>`}
          </div>`;
        })
        .join('');
    }

    updateSummary() {
      const chosen = this.slots.filter(Boolean);
      const prices = chosen.map((s) => this.variantOf(s.product, s.variantId).price);
      const complete = chosen.length === 3;
      const pay = this.querySelector('[data-deal-pay]');
      const full = this.querySelector('[data-deal-full]');
      if (complete) {
        const sum = prices.reduce((a, b) => a + b, 0);
        const free = Math.min(...prices);
        pay.textContent = this.money(sum - free);
        full.textContent = this.money(sum);
        this.savingEl.textContent = this.t.tSaving.replace('{amount}', this.money(free));
      }
      const threeMode = this.mode === 'three';
      this.savingEl.hidden = !(threeMode && complete);
      this.addBtn.hidden = !threeMode;
      this.addBtn.disabled = !complete;
      if (this._adding) return;
      this.addBtn.textContent = complete ? this.t.tAdd : this.t.tMore.replace('{n}', String(3 - chosen.length));
    }

    /* ---------- eventos ---------- */
    onSelect(e) {
      const sel = e.target;
      if (!(sel instanceof HTMLSelectElement)) return;
      if (sel.hasAttribute('data-one-size')) {
        this.oneVariantId = Number(sel.value);
        this.slots[0] = { product: this.current, variantId: this.oneVariantId };
        // sincroniza el selector de talla principal de la ficha
        const input = document.querySelector(`variant-picker input[data-variant-id="${this.oneVariantId}"]`);
        if (input && !input.checked) input.click();
      } else if (sel.hasAttribute('data-slot-size')) {
        const i = Number(sel.getAttribute('data-slot-size'));
        this.slots[i].variantId = Number(sel.value);
        if (i === 0) this.oneVariantId = this.slots[0].variantId;
        this.updateSummary();
      } else if (sel.hasAttribute('data-modal-size')) {
        // solo guarda la talla elegida en esa fila de la ventana
      }
    }

    onClick(e) {
      const choose = e.target.closest('[data-choose]');
      if (choose) return this.openModal(Number(choose.dataset.choose));
      const close = e.target.closest('[data-modal-close]');
      if (close) return this.modal.close();
      const pick = e.target.closest('[data-pick]');
      if (pick) {
        const row = pick.closest('[data-item]');
        const product = this.products.find((p) => p.id === Number(row.dataset.item));
        const variantId = Number(row.querySelector('[data-modal-size]').value);
        this.slots[this._slot] = { product, variantId };
        this.modal.close();
        this.renderThree();
        this.updateSummary();
      }
    }

    openModal(slot) {
      this._slot = slot;
      const items = this.products
        .map((p) => {
          const first = p.variants.find((v) => v.available);
          const sel = this.sizeSelect(p, first.id, 'data-modal-size');
          return `<div class="sc-offer__item" data-item="${p.id}">
            ${this.thumb(p)}
            <div class="sc-offer__slot-info">
              <span class="sc-offer__slot-title">${esc(p.title)}</span>
              <span class="sc-offer__item-price">${this.money(first.price)}</span>
              ${sel}
            </div>
            <button type="button" class="sc-offer__btn" data-pick>${esc(this.t.tChoose)}</button>
          </div>`;
        })
        .join('');
      this.modal.innerHTML = `
        <div class="sc-offer__modal-head">
          <span>${esc(this.t.tModalTitle)}</span>
          <button type="button" class="sc-offer__modal-close" data-modal-close aria-label="${esc(this.t.tClose)}">&times;</button>
        </div>
        <div class="sc-offer__modal-list">${items}</div>`;
      this.modal.showModal();
    }

    /* ---------- carrito ---------- */
    async addToCart() {
      if (this.slots.some((s) => !s) || this._adding) return;
      this._adding = true;
      this.addBtn.disabled = true;
      this.addBtn.textContent = this.t.tAdding;
      this.errorEl.hidden = true;
      const qty = {};
      this.slots.forEach((s) => {
        qty[s.variantId] = (qty[s.variantId] || 0) + 1;
      });
      try {
        const res = await fetch(this.dataset.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: Object.entries(qty).map(([id, quantity]) => ({ id: Number(id), quantity })) }),
        });
        if (!res.ok) throw new Error('add failed');
        window.location.href = this.dataset.cartUrl;
      } catch (err) {
        this._adding = false;
        this.errorEl.textContent = this.t.tError;
        this.errorEl.hidden = false;
        this.updateSummary();
      }
    }
  }

  customElements.define('scuderia-bundle', ScuderiaBundle);
})();
